// extracted by mini-css-extract-plugin
module.exports = {"centering":"centering__5a_S7"};